import React from 'react'
import Quill from 'react-quill'
import Interface from '../../interface/input'

export default ({ className, onChange, value }: Interface) => (
  <Quill className={className} onChange={onChange} value={value} />
)
